export const token = {
    fontFamily: "PingFang SC,Helvetica Neue,Microsoft Yahei,system-ui,'-apple-system',segoe ui,Roboto,Helvetica,Arial,sans-serif,apple color emoji,segoe ui emoji,segoe ui symbol",
    fontSize: 14,
    l1FontSize: 32,
    l1LineHeight: "150%",
    l2FontSize: 20,
    l2LineHeight: "140%",
    l3FontSize: 16,
    l3LineHeight: "150%",
    l4FontSize: 14,
    l4LineHeight: "150%",
    l5FontSize: 12,
    l5LineHeight: "130%",
    l6FontSize: 10,
    l6LineHeight: "120%"
};
//# sourceMappingURL=default.js.map
